// Release hero: one slide at a time, prev/next, optional autoplay with pause.
// Autoplay stops on hover/focus and when the user prefers reduced motion.
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-pr-hero]').forEach((hero) => {
    const slides = [...hero.querySelectorAll('.pr-hero__slide')];
    if (slides.length < 2) return;

    const current = hero.querySelector('[data-pr-current]');
    const toggle = hero.querySelector('[data-pr-toggle]');
    let index = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
    let timer = null;
    let playing = hero.dataset.autoplay === 'true' && !reduceMotion;

    const show = (next, animate = true) => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.inert = !active;
        if (!active) slide.classList.remove('is-entering');
      });
      if (current) current.textContent = index + 1;
      if (!animate || reduceMotion) return;

      // Spray-paint wipe on the cover, record slides out, text + title letters come in after it (CSS).
      const slide = slides[index];
      const title = slide.querySelector('.pr-hero__title');
      slide.classList.remove('is-entering');
      title?.classList.remove('is-inview');
      void slide.offsetWidth; // restart the CSS animations
      slide.classList.add('is-entering');
      setTimeout(() => title?.classList.add('is-inview'), 380);
    };

    const stop = () => {
      clearInterval(timer);
      timer = null;
    };

    const start = () => {
      stop();
      if (playing) timer = setInterval(() => show(index + 1), Number(hero.dataset.speed) || 7000);
    };

    const setPlaying = (value) => {
      playing = value;
      if (toggle) toggle.textContent = playing ? toggle.dataset.labelPause : toggle.dataset.labelPlay;
      playing ? start() : stop();
    };

    hero.classList.add('is-enhanced');
    show(index, false);

    hero.querySelector('[data-pr-prev]')?.addEventListener('click', () => {
      show(index - 1);
      start();
    });
    hero.querySelector('[data-pr-next]')?.addEventListener('click', () => {
      show(index + 1);
      start();
    });
    toggle?.addEventListener('click', () => setPlaying(!playing));

    if (toggle && reduceMotion) setPlaying(false);

    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);
    hero.addEventListener('focusin', stop);
    hero.addEventListener('focusout', (event) => {
      if (!hero.contains(event.relatedTarget)) start();
    });

    start();
  });
})();
